import { isEmpty, trimRight } from "@/utils";

export class DataErrorParser {
  note = "";
  error = null;
  status = "";
  statusText = "";
  code = "";
  message = "";
  details = "";
  validationErrors = [];

  constructor(error, note) {
    this.error = error || "";
    this.note = trimRight(note, ["."]);

    if (!this.error) {
      return;
    }

    const response = this.error.response;
    if (!response) {
      if (!isEmpty(this.error.message)) {
        this.message = this.error.message;
        if (!isEmpty(this.error.code)) {
          this.code = this.error.code;
        }
        return;
      }

      this.message = this.stringify(this.error);
      return;
    }

    this.status = response.status ? response.status : null;
    this.statusText = response.statusText ? response.statusText : "";

    const data = response.data;
    if (!data) {
      this.message = this.stringify(this.error);
      return;
    }

    if (typeof data === "string") {
      this.message = data || "";
      return;
    }

    const dataError = data.error;
    if (typeof dataError === "object") {
      this.message = dataError.message || "";
      this.code = dataError.code || "";
      this.details = dataError.details || "";
      this.validationErrors = dataError.validationErrors || [];
      return;
    }

    this.message = this.stringify(this.error);
  }

  fullMessage() {
    let msg = this.formatMessage(
      this.trimRightDot(this.note),
      this.trimRightDot(this.message)
    );
    if (isEmpty(this.details)) {
      return msg;
    }
    return this.formatMessage(
      this.trimRightDot(msg),
      this.trimRightDot(this.details)
    );
  }
  trimRightDot(text) {
    return trimRight(text, ["."]);
  }
  formatMessage(...args) {
    return args ? args.join(". ") : "";
  }
  stringify(text) {
    return JSON.stringify(text || "");
  }
  getStatus() {
    return this.status;
  }
  getStatusText() {
    return this.statusTexttus;
  }
  getCode() {
    return this.code || "";
  }
  getMessage() {
    return this.message || "";
  }
  getValidationErrors() {
    if (!this.validationErrors) {
      return [];
    }
    return this.validationErrors.map(el => el.message);
  }
}
